import { Outlet } from 'react-router-dom';

import { useSessionBootstrap } from '@/app/providers/useSessionBootstrap';

/**
 * Outer-most route element. Wires in side effects that must run for every
 * navigation regardless of auth state — most importantly `useSessionBootstrap`,
 * which hydrates the session from `/auth/me` at app start and keeps it in
 * sync across tabs.
 */
export function RootLayout() {
  useSessionBootstrap();
  return <Outlet />;
}
